import { useEffect, useMemo, useState } from 'react';

import { DataTableColumnSorting } from '../components/data-table/data-table';

export const usePagination = <T extends Record<string, any>>(
  pageSize: number | undefined,
  items: T[],
  sortingSettings: DataTableColumnSorting | undefined,
) => {
  const [_, setItemCount] = useState(items.length);
  const [currentPage, setCurrentPage] = useState<number | undefined>(pageSize ? 1 : undefined);

  const onPageChange = (page: number): void => setCurrentPage(page);

  const paginatedItems = useMemo(() => {
    if (!pageSize || !currentPage) {
      return undefined;
    }

    const firstIndex = (currentPage - 1) * pageSize;
    return items.slice(firstIndex, firstIndex + pageSize);
  }, [currentPage, pageSize, items]);

  // Return to first page if total item count decreases.
  useEffect(() => {
    setItemCount((oldValue) => {
      if (oldValue > items.length) {
        setCurrentPage(1);
      }

      return items.length;
    });
  }, [items]);

  // Return to first page page size or sorting settings changes.
  useEffect(() => {
    if (pageSize) {
      setCurrentPage(1);
    }
  }, [pageSize, sortingSettings]);

  return { currentPage, onPageChange, paginatedItems };
};
